import { OwcTypography } from "@one/react";
import { Grid } from "@mui/material";
import { CLUSTER_COVER_SHEET_LIST, COVER_SHEET_LIST } from "../../constants";
import { useSelector } from "react-redux";
import { coverSheetValuesComponents, DisplayItemValueDefault } from "./DisplayFunctions";
import { DigitalLabLogbookInstrumentModelType } from "../../models/DigitalLabLogbookInstrumentModelType";
import { RootState } from "../../reducers";
import { THEME } from "@digitallab/grid-common-frontend-components";
import { react18WorkaroundProps } from "../../utils/constants/react18WorkaroundProps";

export const CoverSheetData = ({
  equipmentDetail,
  snapShotView,
  coverSheetFields
}: {
  equipmentDetail: DigitalLabLogbookInstrumentModelType;
  snapShotView: boolean;
  coverSheetFields: typeof COVER_SHEET_LIST | typeof CLUSTER_COVER_SHEET_LIST;
}) => {
  const gxpReadys = useSelector((store: RootState) => store.runLogsForm.gxpReadys);
  return (
    <Grid container spacing={1} data-testid="cover-sheet-data">
      {equipmentDetail &&
        Object.keys(coverSheetFields).map((coverSheetItem) => {
          const properties = {
            snapShotView,
            equipmentDetail,
            gxpReadys
          };

          return (
            <Grid item xs={2} key={coverSheetItem}>
              <OwcTypography
                variant="body2"
                {...react18WorkaroundProps}
                style={{ fontSize: '12px', fontFamily: THEME['one-text-font-family-default'], letterSpacing: "0.00938em" }}
              >
                {coverSheetFields[coverSheetItem as keyof typeof coverSheetFields].label}
              </OwcTypography>

              <strong style={{ fontWeight: THEME['one-text-font-weight-700'], fontFamily: THEME['one-typography-font-family']}}>
                {coverSheetValuesComponents.get(coverSheetItem)?.(properties) ||
                  DisplayItemValueDefault(equipmentDetail, coverSheetItem)}
              </strong>
            </Grid>
          );
        })}
      <Grid item xs={2} />
    </Grid>
  );
};
